import { render, staticRenderFns } from "./makeupRecords.vue?vue&type=template&id=078694d2&scoped=true&"
import script from "./makeupRecords.vue?vue&type=script&lang=js&"
export * from "./makeupRecords.vue?vue&type=script&lang=js&"
import style0 from "./makeupRecords.vue?vue&type=style&index=0&id=078694d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078694d2",
  null
  
)

export default component.exports